import { FormControl, Validators } from '@angular/forms';
import { ColumnProfile } from 'src/app/services/API.service';

export class ColumnForm {
    HeaderTxt = new FormControl();
    Field = new FormControl();

    constructor(col: ColumnProfile) {

        if (col) {
            this.HeaderTxt.setValue(col.HeaderTxt);
            this.Field.setValue(col.Field);
        }

        this.HeaderTxt.setValidators([Validators.required]);
        this.Field.setValidators([Validators.required]);
    }
}